import React from 'react';
import EventsEditForm from '../EventsEditForm';

class EventsNew extends React.Component {

  componentDidMount() {
    this.props.init();
  }

  render() {
    return (
        <EventsEditForm label="Create Event" {...this.props}/>
    );
  }
}

export default EventsNew;


// WEBPACK FOOTER //
// ./src/components/Events/EventsNew/EventsNew.js